import React, { Component } from 'react'
import { Link } from 'react-router'
import LicensePlate from './../../LicensePlate'
import Icon from './../../../elements/icon'
import { ProductionStatus } from './../../../elements/icons'

import './overvieworderitem.scss'
import { translation } from '../../../../utils/helpers'

class OverviewOrderItem extends Component {

  getIcon (orderStep) {
    switch (orderStep) {
      // Draft = 0,
      // New = 1,
      // BodyShopDisassemply = 101,
      // BodyShopRepair = 102,
      // BodyShopPainting = 105,
      // Pretreatment = 2,
      // Filling = 3,
      // Sanding = 4,
      // Painting = 5,
      // Finishing = 6,
      // BodyShopAssemply = 103,
      // BodyShopFinishing = 104,
      // Delivery = 7,
      // Archive = 8
      case 0:
      case 1:
        return ProductionStatus.Step_New
      case 2:
        return ProductionStatus.Step_Preparing
      case 3:
        return ProductionStatus.Step_Filler
      case 4:
        return ProductionStatus.Step_Sanding
      case 5:
        return ProductionStatus.Step_Painting
      case 6:
        return ProductionStatus.Step_Finishing
      case 7:
        return ProductionStatus.Step_Handover
      case 101:
        return ProductionStatus.Step_BodyShopDisassemply
      case 102:
        return ProductionStatus.Step_BodyShopRepair
      case 103:
        return ProductionStatus.Step_BodyShopAssembly
      case 104:
        return ProductionStatus.Step_BodyShopFinishing
      case 105:
        return ProductionStatus.Step_Painting
    }
  }

  render () {
    let brandName = this.props.BrandName === '2000' ? translation(this.props.BrandName) : this.props.BrandName
    let orderLink = this.props.OrderId > 0 ? '/orders/' + this.props.OrderId : null
    return (
      <div className='overvieworderitem'>
        <Link to={orderLink}>
          <div className='top'>
            <div className='brand-model'>{brandName + ' ' + this.props.Model}</div>
          </div>
          <div className='bottom'>
            <LicensePlate regNr={this.props.RegNr} countryCode={this.props.CountryCode} />
            <div className='secondarytext'>{this.props.SecondaryText}</div>
            <Icon size='s' icon={this.getIcon(this.props.OrderStep)} />
          </div>
        </Link>
      </div>
    )
  }
}

OverviewOrderItem.defaultProps = {
  OrderId: 0,
  BrandName: '',
  Model: '',
  RegNr: '',
  PlateType: 0,
  OrderStep: 1,
  SecondaryText: null
}

export default OverviewOrderItem



// WEBPACK FOOTER //
// ./src/app/shared/components/Overview/OverviewOrderItem/index.js